import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { confirmAlert } from 'react-confirm-alert';
import ColorUtils from './ColorUtils';
import { Ito } from './Yubinuki';
import YubinukiPallet from './YubinukiPallet';

interface Props {
    index: number,
    ito: Ito,
    onChangeColor: ((itoIndex: number, color: string) => void),
    onChangeRounds: ((itoIndex: number, rounds: number) => void),
    onMoveUp: ((itoIndex: number) => void),
    onMoveDown: ((itoIndex: number) => void),
    onRequestDelete: ((itoIndex: number) => void),
}

// [0...50]
const roundsOptions = Array.from({ length: 51 }, (_,k) => {
    return <option value={k} key={k}>{k}</option>
});

function YubinukiIto(props: Props) {
    function handleChangeRounds(e: React.FormEvent<HTMLSelectElement>) {
        props.onChangeRounds(props.index, parseInt(e.currentTarget.value));
    };
    function handleChangeColorText(e: React.FormEvent<HTMLInputElement>) {
        // FIXME: 即時反映だと色解釈が変なことになるので、遅延させたいな。throttleかdebounce というのがあるらしい
        props.onChangeColor(props.index, e.currentTarget.value);
    };
    function handleMoveUp() {
        props.onMoveUp(props.index);
    };
    function handleMoveDown() {
        props.onMoveDown(props.index);
    };
    function handleRequestDelete() {
        props.onRequestDelete(props.index);
    };
    function handleOpenPallet(e: React.FormEvent<HTMLButtonElement>) {
        confirmAlert({
            customUI: ({ onClose }) => {
                return (
                    <div className="react-confirm-alert customAlert">
                        <div className="alertBody">
                            <h3 className="mb-3">色をパレットから選ぶ</h3>
                            <YubinukiPallet selectedColor={e.currentTarget.value} onClickColor={(e) => { handleSelectColor(e); onClose(); }} />
                            <div className="buttonGroup">
                                <button className="btn" onClick={onClose}>閉じる</button>
                            </div>
                        </div>
                    </div>
                )
            }
        })
    };
    function handleSelectColor(color: string) {
        props.onChangeColor(props.index, color);
    };

    return (
        <div className="ito form-row border-top pt-1 pb-1">
            <div className="form-inline col-12 col-md-6 col-lg-4">
                <button type="button" name="color" className="btn buttonAction buttonColor mr-1" value={props.ito.color} onClick={handleOpenPallet}>
                    <div className="colorBox" style={{ backgroundColor: ColorUtils.formatColor(props.ito.color) }}></div>
                </button>
                <label className="sr-only" htmlFor={`ito-${props.index}-color`}>色</label>
                <input type="text" id={`ito-${props.index}-color`} name="color" className="form-control" maxLength={20} value={props.ito.color} onChange={handleChangeColorText}/>
            </div>

            <div className="form-inline col-12 col-md-6 col-lg-4">
                <select id={`ito-${props.index}-rounds`} value={props.ito.rounds} className="form-control" onChange={handleChangeRounds}>
                    {roundsOptions}
                </select>
                <label htmlFor={`ito-${props.index}-rounds`}>段</label>
            </div>

            <div className="form-inline col-12 col-md-6 col-lg-4">
                <div className="button-group ml-4 mr-2">
                    <button type="button" name="moveUp" className="btn" onClick={handleMoveUp}>
                        <FontAwesomeIcon icon="arrow-up" />
                    </button>
                    <button type="button" name="moveDown" className="btn" onClick={handleMoveDown}>
                        <FontAwesomeIcon icon="arrow-down" />
                    </button>
                </div>
                <div className="button-group">
                    <button type="button" name="trash" className="btn" onClick={handleRequestDelete}>
                        <FontAwesomeIcon icon="trash-alt" />
                    </button>
                </div>
            </div>
        </div>
    )
}

export default YubinukiIto;